import RCustomGuandong from './RCustomGuangdong'
import RHomeOrganization, * as homeOrganizationRouter from './RHomeOrganization'
import RCustomCompetition, * as customCompetitionRouter from './RCustomCompetition'

import RCompetitionOrganization, {
  regionRouter as competitionRegionRouter,
  videoRegionRouter as videoCompetitionRegionRouter,
} from './RCompetitionOrganization'

const Layout = () => import('../views/Layout.vue')
const LayoutEmpty = () => import('../views/LayoutEmpty.vue')

export default [
  {
    path: '/organization',
    name: 'organization',
    component: Layout,
    redirect: RCompetitionOrganization[0],
    children: [...RHomeOrganization, ...RCompetitionOrganization],
  },
  {
    path: '/organization/custom',
    name: 'organization_custom',
    component: LayoutEmpty,
    redirect: customCompetitionRouter.dashboardRoute,
    children: [...RCustomGuandong.slice(1), ...RCustomCompetition.slice(1)],
  },
]

export { homeOrganizationRouter, competitionRegionRouter, videoCompetitionRegionRouter }
